/**
 * UserStatistics
 *
 * @component userstatistics
 */

import ClassLogger from 'ClassLogger';
import Api from './_api.js';

class UserStatistics {

    constructor() {
        let self = this;
        self.logger = ClassLogger(self, true);

        if ($('[data-user-stats]').length === 0) {
            return;
        }
        self.init();
    }

    init() {
        let self = this;
        const url = 'accounts/me/stats';
        self.getStatistics(url);
    }

    getStatistics(url) {
        let self = this;
        // Request Data
        Api.request('GET', url, '')
            .then(function (response) {

                if (typeof response.data !== 'undefined') {
                    // the array is defined and has at least one element
                    self.populateStatistics(response.data);
                }

            }).catch(function (exception) {
                self.logger.error('Processor Error', exception);
                let error_message = 'Es trat ein Fehler auf!';
                if (typeof exception === 'object'
                    && typeof exception.responseJSON === 'object'
                    && typeof exception.responseJSON.error_code !== 'undefined'
                    && typeof exception.responseJSON.error_message === 'string'
                ) {
                    error_message = exception.responseJSON.error_message;
                }
                alert(error_message);

            });

    }

    populateStatistics(data) {
        $('[data-user-stats] [data-user-appointments]').html(data.appointments);
        $('[data-user-stats] [data-user-applications]').html(data.applications);
    }

}

export default new UserStatistics();
